module.exports = __webpack_public_path__ + "img/marine.0893918d.png";